import { useIntl } from 'react-intl';
import { Input } from '../../../../ui';
import { FileUploader } from '../../../../ui/UploadImage/FileUploader';
import { StyledBusinessTab } from '../style';
import type { UploadFile } from 'antd/es/upload';
import { useBreakpoint } from 'utils/useBreakpoint';
interface GalleryProps {
  setFileLogo: React.Dispatch<React.SetStateAction<UploadFile<any>[]>>;
  setFileGallery: React.Dispatch<React.SetStateAction<UploadFile<any>[]>>;
  fileGallery: UploadFile<any>[];
  fileLogo: UploadFile<any>[];
}

export const BusinessGallery = ({
  setFileLogo,
  setFileGallery,
  fileGallery,
  fileLogo,
}: GalleryProps) => {
  const intl = useIntl();
  const { isLgDown } = useBreakpoint();

  return (
    <StyledBusinessTab>
      <div className={'wide-section'}>
        <div className={'title'}>
          <h3>{intl.formatMessage({ id: 'gallery.logo' })}</h3>
        </div>
        <div className={'input-filelist'}>
          <div className={'input'}>
            <FileUploader
              fileList={fileLogo}
              onFileListChange={setFileLogo}
              showActions={true}
              multiple={false}
              title={null}
              isCrop={true}
              horizontal={isLgDown ? false : true}
              aspectRatio={1 / 1}
            />
          </div>
        </div>
        <div className={'gallery'}>
          <div className={'title'}>
            <h3>{intl.formatMessage({ id: 'gallery.business_gallery' })}</h3>
          </div>
          <FileUploader
            fileList={fileGallery}
            onFileListChange={setFileGallery}
            showActions={true}
            multiple={true}
            title={null}
            isCrop={true}
            horizontal={isLgDown ? false : true}
            aspectRatio={16 / 9}
          />
        </div>
        <div className={'video'}>
          <div className={'title'}>
            <h3>{intl.formatMessage({ id: 'gallery.product_video' })}</h3>
            {intl.formatMessage({ id: 'gallery.video_description' })}
          </div>
          <Input
            label={intl.formatMessage({ id: 'gallery.youtube_link' })}
            name={'youtube_link'}
            layout={'vertical'}
            className={'yt'}
          />
        </div>
      </div>
    </StyledBusinessTab>
  );
};
